import Component from '@glimmer/component'
import assignmentsGreen from '@images/homeschool-ui-icons/assignments_green.svg'
import assignmentsBlue from '@images/homeschool-ui-icons/assignments_blue.svg'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import HomeschoolBaseTile from 'teacher-ui-client/components/home/tiles/homeschool/base-tile'
import { t } from 'ember-intl'
import { TileButton } from 'teacher-ui-client/components/home/tiles/homeschool/button'
import { array } from '@ember/helper'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'

interface Signature {
  Args: {
    subscriptionType: SubscriptionType.Reading | SubscriptionType.Maths
  }
  Element: Element
}

export class CreateAssignmentsTile extends Component<Signature> {
  get isMathsSubscription() {
    return this.args.subscriptionType === SubscriptionType.Maths
  }

  get isReadingSubscription() {
    return this.args.subscriptionType === SubscriptionType.Reading
  }

  <template>
    {{#if this.isMathsSubscription}}
      <HomeschoolBaseTile
        @themeKey={{ThemeKeys.green}}
        @imgSrc={{assignmentsBlue}}
        @imgAlt={{t "pages.home.panels.homeschool.createAssignments.imageAlt"}}
        @title={{t "pages.home.panels.homeschool.createAssignments.title"}}
        @tileDescription={{t "pages.home.panels.homeschool.createAssignments.description"}}
      >
        <div class="flex flex-col items-center space-y-4 text-center">
          <TileButton
            @title={{t "pages.home.panels.homeschool.createAssignments.buttonText.ms"}}
            @themeKey={{ThemeKeys.blue}}
            @route="assignments.product.create"
            @models={{array "mathseeds"}}
            data-test-homeschool-create-assignments-button-ms
          />
        </div>

      </HomeschoolBaseTile>

    {{else if this.isReadingSubscription}}
      <HomeschoolBaseTile
        @themeKey={{ThemeKeys.blue}}
        @imgSrc={{assignmentsGreen}}
        @imgAlt={{t "pages.home.panels.homeschool.createAssignments.imageAlt"}}
        @title={{t "pages.home.panels.homeschool.createAssignments.title"}}
        @tileDescription={{t "pages.home.panels.homeschool.createAssignments.description"}}
      >
        <div class="flex flex-col items-center space-y-4 text-center">
          <TileButton
            @title={{t "pages.home.panels.homeschool.createAssignments.buttonText.re"}}
            @themeKey={{ThemeKeys.blue}}
            @models={{array "reading-eggs"}}
            @route="assignments.product.create"
            data-test-homeschool-create-assignments-button-re
          />
          <TileButton
            @title={{t "pages.home.panels.homeschool.createAssignments.buttonText.rex"}}
            @themeKey={{ThemeKeys.purple}}
            @models={{array "reading-eggspress"}}
            @route="assignments.product.create"
            data-test-homeschool-create-assignments-button-rex
          />
          <TileButton
            @title={{t "pages.home.panels.homeschool.createAssignments.buttonText.fp"}}
            @themeKey={{ThemeKeys.pink}}
            @models={{array "fast-phonics"}}
            @route="assignments.product.create"
            data-test-homeschool-create-assignments-button-fp
          />
        </div>
      </HomeschoolBaseTile>

    {{/if}}
  </template>
}

export default CreateAssignmentsTile
